import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { RECAPTCHA_KEY } from 'config';
import { Deferred } from 'types';
import { createDeferred } from 'utils';

type Props = {
  type?: GCP<ReCAPTCHA>['size'],
  onToken?: (token: string | null) => void,
};

class Recaptcha extends React.PureComponent<Required<Props>> {
  static defaultProps: OptionalProps<Props> = {
    type: 'invisible',
  };

  private deferred: Deferred<string | null> | null = null;
  private ref = React.createRef<ReCAPTCHA>();

  componentDidCatch() {
    // catch errors that happen on edge during unmounting
  }

  private onChange = (token: string | null) => {
    if (this.props.onToken) {
      this.props.onToken(token);
    }

    if (this.deferred) {
      if (token !== null) this.deferred.resolve(token);
      else this.deferred.reject('Recaptcha error!');

      this.deferred = null;
    }
  };
  private onError = () => {
    if (this.deferred) {
      this.deferred.reject('Recaptcha error!');
      this.deferred = null;
    }
  };

  execute(): Promise<string | null> {
    if (!this.ref.current) throw new Error('Recaptcha not ready!');

    this.ref.current.execute();
    const { deferred, promise } = createDeferred<string | null>();
    this.deferred = deferred;
    return promise;
  }
  reset() {
    if (!this.ref.current) return;
    this.ref.current.reset();
  }
  getValue() {
    if (!this.ref.current) return null;
    return this.ref.current.getValue();
  }

  render() {
    return (
      <ReCAPTCHA
        ref={ this.ref }
        sitekey={ RECAPTCHA_KEY }
        size={ this.props.type }
        badge="bottomleft"
        onChange={ this.onChange }
        onExpired={ this.onError }
      />
    );
  }
}

export default Recaptcha;



